import React from 'react';

// Error Boundary for DeveloperPage - Check #2
class DeveloperPageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // CRITICAL: If DeveloperPage fails, the app should not work
    console.error('❌ CRITICAL ERROR: DeveloperPage Error Boundary caught an error:', error, errorInfo);
    console.error('The DeveloperPage is required. The application cannot function without it.');
    // Re-throw to prevent app from working
    this.setState({ hasError: true, error });
    // Also throw to ensure app fails
    throw error;
  }

  render() {
    if (this.state.hasError) {
      // CRITICAL: Show error and prevent app from working
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
          textAlign: 'center',
          background: '#fee',
          border: '3px solid #f00'
        }}>
          <h1 style={{ marginBottom: '16px', color: '#c00', fontSize: '24px', fontWeight: 'bold' }}>
            ❌ CRITICAL ERROR: DeveloperPage Required
          </h1>
          <p style={{ marginBottom: '8px', color: '#900', fontSize: '18px', fontWeight: '600' }}>
            The DeveloperPage has been deleted or is missing.
          </p>
          <p style={{ marginBottom: '24px', color: '#666', fontSize: '16px' }}>
            The application CANNOT function without DeveloperPage.
          </p>
          <p style={{ marginBottom: '24px', color: '#333', fontSize: '14px', fontFamily: 'monospace', background: '#fff', padding: '12px', borderRadius: '4px' }}>
            Required file: frontend/src/pages/DeveloperPage.jsx
          </p>
          <p style={{ marginBottom: '24px', color: '#c00', fontSize: '14px' }}>
            Please restore the DeveloperPage file to continue using the application.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default DeveloperPageErrorBoundary;

